import { render, staticRenderFns } from "./image_viewer.vue?vue&type=template&id=5a4b2552"
import script from "./image_viewer.vue?vue&type=script&lang=js"
export * from "./image_viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports